/**
 * The Guided pair columns (DESIGN.md §4.7): ONE rule shared by the motion columns (W2-04a, which shows a pair as one
 * column with two lanes) and the curve editor (W2-04b, which shows both lanes of an expanded pair). At the Guided
 * level, on layer 0 of the active line: Position X | Y always; Size W | H on image-like lines (texture, GIF, text
 * lines and UI movers). Pure; the callers check the level, the layer and the active line.
 */

import type { LineKind, LineProp } from '../../../core/model/types';

export type MotionPairKind = 'position' | 'size';

export interface MotionPair {
  readonly kind: MotionPairKind;
  readonly props: readonly [LineProp, LineProp];
}

const POSITION: MotionPair = Object.freeze({ kind: 'position', props: Object.freeze(['moveX', 'moveY'] as const) });
const SIZE: MotionPair = Object.freeze({ kind: 'size', props: Object.freeze(['scaleX', 'scaleY'] as const) });

/** Lines whose size is edited as W | H (and that show the colour column). */
export function isImageLikeLine(kind: LineKind, uiMover: boolean): boolean {
  return kind === 'texture' || kind === 'gif' || kind === 'text' || uiMover;
}

/** The Guided pair a property belongs to on a line of this kind, or null when it is shown on its own. */
export function guidedPairOf(prop: LineProp, kind: LineKind, uiMover: boolean): MotionPair | null {
  if (prop === 'moveX' || prop === 'moveY') return POSITION;
  if ((prop === 'scaleX' || prop === 'scaleY') && isImageLikeLine(kind, uiMover)) return SIZE;
  return null;
}
